import type { GlobalState } from '../index';

export const selectReviewsList = (state: GlobalState) => state.reviews.list;
export const selectReviewItem = (state: GlobalState) => state.reviews.review;
export const selectReviewPostingState = (state: GlobalState) => state.reviews.postReview;
export const selectCurrentReviewType = (state: GlobalState) => state.reviews.currentReviewType;
export const selectReviewsCount = (state: GlobalState) => state.reviews.aggregatedCount;
export const selectReviewsStats = (state: GlobalState) => state.reviews.stats;
export const selectListQuery = (state: GlobalState) => state.reviews.listQuery;
export const selectSqueeze = (state: GlobalState) => state.reviews.squeeze.items;
